export function formatLocalDayLabel(): string {
  try {
    return new Date().toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  } catch {
    return "today";
  }
}

export function percentFromFraction(done: number, total: number): number {
  if (total <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((done / total) * 100)));
}
